/**
 * Returns true if the given pathname (defaults to the current browser location)
 * represents an AI mode path, i.e. starts with "/ai/".
 */
export function isAiModePath(
  pathname: string = window.location.pathname
): boolean {
  return pathname.startsWith("/ai/");
}
